export default "__VITE_ASSET__acbcf97b__"